import React, {useState} from 'react'
import './ContactStructure.css'
import { useSelector } from 'react-redux'
import {translation} from "../I18n/i18n"
import PhoneIcon from '@material-ui/icons/Phone';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import MailIcon from '@material-ui/icons/Mail';

function ContactStructure() {

    const lang = useSelector(state => state.languageReducer.language)
    const [mailIsShow,setMailIsShow] = useState(false)

    return (
        <div>
        <div className='contact__page'>
            <div className='contact__faq'>
                <h1>{translation(lang,"qa")}</h1>
                <details>  
                    <summary>{translation(lang,"q1")}</summary>  
                    <p>{translation(lang,"a1-1")}</p>
                    <p>{translation(lang,"a1-2")}</p>
                </details>
                <details>  
                    <summary>{translation(lang,"q2")}</summary>  
                    <p>{translation(lang,"a2")}</p>
                    <p></p>
                </details>
                <details>  
                    <summary>{translation(lang,"q3")}</summary>  
                    <p>{translation(lang,"a3")}</p>
                    <p></p>
                </details>
                <details>  
                    <summary>{translation(lang,"q4")}</summary>  
                    <p>{translation(lang,"a4")}</p>
                    <p></p>
                </details>
            </div>

            {/* <div className='contact__form'>
                <form>
                    <input type='text' placeholder='Nom'></input>
                    <input type='text' placeholder='Prenom'></input>
                    <input type='text' placeholder='Nom de votre société'></input>
                    <input type='text' placeholder='télNom de votre éphone pour être recontacté'></input>
                    <input type='email' placeholder='votre email pour être recontacté'></input>
                    <textarea type='text' placeholder='rentrez les références et quantité des machines voulues ici'></textarea>
                    <button type='submit' className='send__btn'>Envoyer</button>
                </form>
            </div> */}
            <div className='contact__page_infosBox'>
                <h2>{translation(lang,"contactInfos")}</h2>
                <p>{translation(lang,"callUs")}</p>
                {/* <a href="fax:+33500000000"> <div className='contact__page_phone'><PhoneIcon/>(+33) 9 86 06 05 78</div></a> */}
                <p>{translation(lang,"days")}</p>
                <p>{translation(lang,"days2")}</p>
                <p>Tel : 06.61.95.65.73</p>
                <div className='contact__page_emailBtn' onClick={()=>setMailIsShow(!mailIsShow)}><MailIcon/>{mailIsShow?'myostar-contact@gmail.com':'E-Mail'}</div>
                <div className='contact__page_socialMediaIcon'>
                    <a href='https://twitter.com/myostar7'><TwitterIcon/></a>
                    <a href='https://www.instagram.com/myostar_fitness/'><InstagramIcon/></a>
                    <a href='https://www.facebook.com/Myostar-100616025377435'><FacebookIcon/></a>
                </div>
            </div>
            </div>
        </div>
    )
}

export default ContactStructure
